import { atomFamily } from "recoil";

import { TABLE_BULK_SELECTION_DEFAULT_ROW_COUNT } from "../../constants";
import { BulkGridSelectionModeEnum } from "../../enums";
import { RydeUiUnit } from "../../models";

export const bulkGridSelectionModeAF = atomFamily<
  BulkGridSelectionModeEnum,
  RydeUiUnit
>({
  key: "bulkGridSelectionModeAF",
  default: BulkGridSelectionModeEnum.All,
});

export const bulkGridSelectionRowCountAF = atomFamily<number, RydeUiUnit>({
  key: "bulkGridSelectionRowCountAF",
  default: TABLE_BULK_SELECTION_DEFAULT_ROW_COUNT,
});

/** Set when "Select rows" must apply after grouping is cleared. */
export const bulkGridSelectionPendingRowsApplyAF = atomFamily<
  boolean,
  RydeUiUnit
>({
  key: "bulkGridSelectionPendingRowsApplyAF",
  default: false,
});

/** True while the row-count field is focused — selection and mode must not react to each keystroke. */
export const bulkGridSelectionRowCountEditingAF = atomFamily<
  boolean,
  RydeUiUnit
>({
  key: "bulkGridSelectionRowCountEditingAF",
  default: false,
});

/** Last server-resolved id set for bulk scope (all / first N) on server-paginated grids. */
export const bulkGridSelectionServerScopeIdsAF = atomFamily<
  number[],
  RydeUiUnit
>({
  key: "bulkGridSelectionServerScopeIdsAF",
  default: [],
});
